import React, { useState } from 'react';
import './LanguageModal.css';

function LanguageModal({ onSelect, onBack }) {
    const [isSelecting, setIsSelecting] = useState(false);

    const handleSelect = (lang) => {
        if (isSelecting) return;
        setIsSelecting(true);
        onSelect(lang);
    };

    return (
        <div className="lang-modal-overlay">
            <div className="lang-modal-card">
                {/* Back button */}
                <button
                    className="lang-modal-back"
                    onClick={() => {
                        if (isSelecting) return;
                        onBack();
                    }}
                    title="Go back to Home"
                    disabled={isSelecting}
                >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M15 18l-6-6 6-6" />
                    </svg>
                </button>

                {/* Glow orb top */}
                <div className="lang-modal-orb">
                    <span className="lang-modal-icon">🕉️</span>
                </div>

                <h2 className="lang-modal-title">
                    Welcome to<br />
                    <span className="lang-modal-name">Talk to Krishna</span>
                </h2>

                <p className="lang-modal-subtitle">
                    Choose the language in which<br />you'd like Lord Krishna to respond
                </p>

                <div className="lang-modal-options">
                    <button
                        className={`lang-btn lang-btn-english ${isSelecting ? 'disabled' : ''}`}
                        onClick={() => handleSelect('en')}
                        disabled={isSelecting}
                    >
                        <span className="lang-btn-flag">🇬🇧</span>
                        <span className="lang-btn-label">English</span>
                        <span className="lang-btn-sub">Respond in English</span>
                    </button>

                    <div className="lang-divider">or</div>

                    <button
                        className={`lang-btn lang-btn-hindi ${isSelecting ? 'disabled' : ''}`}
                        onClick={() => handleSelect('hi')}
                        disabled={isSelecting}
                    >
                        <span className="lang-btn-flag">🇮🇳</span>
                        <span className="lang-btn-label">हिंदी</span>
                        <span className="lang-btn-sub">हिंदी में उत्तर दें</span>
                    </button>

                    <div className="lang-divider">or</div>

                    <button
                        className={`lang-btn lang-btn-tamil ${isSelecting ? 'disabled' : ''}`}
                        onClick={() => handleSelect('ta')}
                        disabled={isSelecting}
                    >
                        <span className="lang-btn-flag">🇮🇳</span>
                        <span className="lang-btn-label">தமிழ்</span>
                        <span className="lang-btn-sub">தமிழில் பதிலளிக்கவும்</span>
                    </button>
                </div>

                <p className="lang-modal-note">
                    You can speak in Hindi, English or Tamil — Krishna will respond in your chosen language.
                </p>
            </div>
        </div>
    );
}

export default LanguageModal;
